// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map = require("../Data.Map/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Sudoku_Internal = require("../Sudoku.Internal/index.js");
var subGridsToRows = (function () {
    var three = function (v) {
        if (v.length === 3) {
            return new Sudoku_Internal.Tuple3(v[0], v[1], v[2]);
        };
        return new Sudoku_Internal.Tuple3([  ], [  ], [  ]);
    };
    var $125 = Control_Bind.bindFlipped(Control_Bind.bindArray)(function (rows) {
        var v = three(Data_Functor.map(Data_Functor.functorArray)(Sudoku_Internal.chunksOf(3))(rows));
        return Sudoku_Internal.zip3(function (a) {
            return function (b) {
                return function (c) {
                    return Data_Semigroup.append(Data_Semigroup.semigroupArray)(a)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(b)(c));
                };
            };
        })(v.value0)(v.value1)(v.value2);
    });
    var $126 = Sudoku_Internal.chunksOf(3);
    return function ($127) {
        return $125($126($127));
    };
})();
var makeCell = function (v) {
    if (v.length === 0) {
        return Data_Maybe.Nothing.value;
    };
    if (v.length === 1) {
        return Data_Maybe.Just.create(new Sudoku_Internal.Fixed(v[0]));
    };
    return Data_Maybe.Just.create(new Sudoku_Internal.Possible(v));
};
var pruneCellsByFixed = function (cells) {
    var fixeds = Control_Bind.bind(Control_Bind.bindArray)(cells)(function (cell) {
        if (cell instanceof Sudoku_Internal.Fixed) {
            return [ cell.value0 ];
        };
        return [  ];
    });
    var pruneCell = function (v) {
        if (v instanceof Sudoku_Internal.Possible) {
            return makeCell(Data_Array.difference(Data_Eq.eqChar)(v.value0)(fixeds));
        };
        return new Data_Maybe.Just(v);
    };
    return Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe)(pruneCell)(cells);
};
var isPossible = function (v) {
    if (v instanceof Sudoku_Internal.Possible) {
        return true;
    };
    return false;
};
var isInvalidRow = function (row) {
    var fixeds = Control_Bind.bind(Control_Bind.bindArray)(row)(function (cell) {
        if (cell instanceof Sudoku_Internal.Fixed) {
            return [ cell.value0 ];
        };
        return [  ];
    });
    var emptyPossibles = Data_Function.flip(Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean))(row)(function (cell) {
        if (cell instanceof Sudoku_Internal.Possible && cell.value0.length === 0) {
            return true;
        };
        return false;
    });
    return emptyPossibles || Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(Sudoku_Internal.isUnique(Data_Eq.eqChar)(Data_Ord.ordChar))(fixeds);
};
var isFixed = function (v) {
    if (v instanceof Sudoku_Internal.Fixed) {
        return true;
    };
    return false;
};
var isGridFilled = function (grid) {
    return Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(isFixed)(Data_Array.concat(grid));
};
var fixM = function (dictMonad) {
    return function (dictEq) {
        return function (f) {
            return function (x) {
                return Control_Bind.bind(dictMonad.Bind1())(f(x))(function (x$prime) {
                    var $48 = Data_Eq.eq(dictEq)(x$prime)(x);
                    if ($48) {
                        return Control_Applicative.pure(dictMonad.Applicative0())(x);
                    };
                    return fixM(dictMonad)(dictEq)(f)(x$prime);
                });
            };
        };
    };
};
var exclusivePossibilities = (function () {
    var $128 = Data_Array.fromFoldable(Data_List_Types.foldableList);
    var $129 = Data_Map_Internal.filterWithKey(Data_Ord.ordArray(Data_Ord.ordInt))(function (is) {
        return function (xs) {
            return Data_Array.length(is) === Data_Array.length(xs);
        };
    });
    var $130 = Data_Foldable.foldl(Data_List_Types.foldableList)(function (acc) {
        return function (v) {
            return Data_Map_Internal.insertWith(Data_Ord.ordArray(Data_Ord.ordInt))(Data_Semigroup.append(Data_Semigroup.semigroupArray))(v.value1)([ v.value0 ])(acc);
        };
    })(Data_Map_Internal.empty);
    var $131 = Data_Map_Internal.filter(Data_Ord.ordChar)(function ($136) {
        return (function (x) {
            return x < 4;
        })(Data_Array.length($136));
    });
    var $132 = Data_Foldable.foldl(Data_Foldable.foldableArray)(function (acc) {
        return function (v) {
            return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (acc$prime) {
                return function (x) {
                    return Data_Map_Internal.insertWith(Data_Ord.ordChar)(Data_Semigroup.append(Data_Semigroup.semigroupArray))(x)([ v.value0 ])(acc$prime);
                };
            })(acc)(v.value1);
        };
    })(Data_Map_Internal.empty);
    var $133 = Control_Bind.bindFlipped(Control_Bind.bindArray)(function (tuple) {
        if (tuple.value1 instanceof Sudoku_Internal.Possible) {
            return [ new Data_Tuple.Tuple(tuple.value0, tuple.value1.value0) ];
        };
        if (tuple.value1 instanceof Sudoku_Internal.Fixed) {
            return [  ];
        };
        throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 57, column 32 - line 59, column 38): " + [ tuple.constructor.name ]);
    });
    var $134 = Data_Array.zip(Data_Array.range(1)(9));
    return function ($135) {
        return $128(Data_Map_Internal.values($129($130((function (m) {
            return Data_List.zip(Data_List.fromFoldable(Data_Set.foldableSet)(Data_Map.keys(m)))(Data_Map_Internal.values(m));
        })($131($132($133($134($135)))))))));
    };
})();
var pruneCellsByExclusives = function (cells) {
    var exclusives = exclusivePossibilities(cells);
    var allExclusives = Data_Array.concat(exclusives);
    var pruneCell = function (v) {
        if (v instanceof Sudoku_Internal.Fixed) {
            return new Data_Maybe.Just(v);
        };
        if (v instanceof Sudoku_Internal.Possible) {
            var intersection = Data_Array.intersect(Data_Eq.eqChar)(v.value0)(allExclusives);
            var $64 = Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqArray(Data_Eq.eqChar))(intersection)(exclusives);
            if ($64) {
                return makeCell(intersection);
            };
            return new Data_Maybe.Just(v);
        };
        throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 90, column 5 - line 90, column 36): " + [ v.constructor.name ]);
    };
    if (exclusives.length === 0) {
        return new Data_Maybe.Just(cells);
    };
    return Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe)(pruneCell)(cells);
};
var pruneCells = function (cells) {
    return Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(fixM(Data_Maybe.monadMaybe)(Data_Eq.eqArray(Sudoku_Internal.cellEq))(pruneCellsByExclusives))(fixM(Data_Maybe.monadMaybe)(Data_Eq.eqArray(Sudoku_Internal.cellEq))(pruneCellsByFixed)(cells));
};
var diagIdxs = Data_Functor.map(Data_Functor.functorArray)(Data_Semiring.mul(Data_Semiring.semiringInt)(10))(Data_Array.range(0)(8));
var diagonalOf = function (grid) {
    return Data_Maybe.fromMaybe([  ])(Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe)(Sudoku_Internal.index2D(grid))(diagIdxs));
};
var isGridInvalid = function (v) {
    return function (grid) {
        if (v instanceof Sudoku_Internal.UniqueDiagonal) {
            return isInvalidRow(diagonalOf(grid)) || isGridInvalid(Sudoku_Internal.Standard.value)(grid);
        };
        if (v instanceof Sudoku_Internal.Standard) {
            return Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(isInvalidRow)(grid) || (Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(isInvalidRow)(Sudoku_Internal.transpose(grid)) || Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(isInvalidRow)(subGridsToRows(grid)));
        };
        throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 162, column 1 - line 162, column 44): " + [ v.constructor.name, grid.constructor.name ]);
    };
};
var replaceDiagonal = function (row) {
    return function (grid) {
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (grid$prime) {
            return function (v) {
                return Sudoku_Internal.replace2D(v.value1)(v.value0)(grid$prime);
            };
        })(grid)(Data_Array.zip(row)(diagIdxs));
    };
};
var pruneDiag = function (grid$prime) {
    return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Function.flip(replaceDiagonal)(grid$prime))(pruneCells(diagonalOf(grid$prime)));
};
var pruneGrid$prime = function (v) {
    return function (grid) {
        if (v instanceof Sudoku_Internal.UniqueDiagonal) {
            return Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(pruneDiag)(pruneGrid$prime(Sudoku_Internal.Standard.value)(grid));
        };
        if (v instanceof Sudoku_Internal.Standard) {
            return Control_Bind.bind(Data_Maybe.bindMaybe)(Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe)(pruneCells)(grid))((function () {
                var $137 = Data_Functor.map(Data_Maybe.functorMaybe)(Sudoku_Internal.transpose);
                var $138 = Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe)(pruneCells);
                return function ($139) {
                    return $137($138(Sudoku_Internal.transpose($139)));
                };
            })()))((function () {
                var $140 = Data_Functor.map(Data_Maybe.functorMaybe)(subGridsToRows);
                var $141 = Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe)(pruneCells);
                return function ($142) {
                    return $140($141(subGridsToRows($142)));
                };
            })());
        };
        throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 100, column 1 - line 100, column 44): " + [ v.constructor.name, grid.constructor.name ]);
    };
};
var pruneGrid = (function () {
    var $143 = fixM(Data_Maybe.monadMaybe)(Data_Eq.eqArray(Data_Eq.eqArray(Sudoku_Internal.cellEq)));
    return function ($144) {
        return $143(pruneGrid$prime($144));
    };
})();
var choices = function (v) {
    if (v instanceof Sudoku_Internal.Fixed) {
        return 0;
    };
    if (v instanceof Sudoku_Internal.Possible) {
        return Data_Array.length(v.value0);
    };
    throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 127, column 1 - line 127, column 23): " + [ v.constructor.name ]);
};
var nextGrids = function (grid) {
    var possibilities = Data_Array.filter(function ($145) {
        return isPossible(Data_Tuple.snd($145));
    })(Data_Array.zip(Data_Array.range(0)(81))(Data_Array.concat(grid)));
    var fixCell = function (v) {
        if (v.value1 instanceof Sudoku_Internal.Possible && v.value1.value0.length === 2) {
            return Data_Maybe.Just.create(new Sudoku_Internal.Tuple3(v.value0, new Sudoku_Internal.Fixed(v["value1"]["value0"][0]), new Sudoku_Internal.Fixed(v["value1"]["value0"][1])));
        };
        if (v.value1 instanceof Sudoku_Internal.Possible) {
            return Data_Functor.map(Data_Maybe.functorMaybe)(function (x) {
                return new Sudoku_Internal.Tuple3(v.value0, new Sudoku_Internal.Fixed(x.head), new Sudoku_Internal.Possible(x.tail));
            })(Data_Array.uncons(v.value1.value0));
        };
        return Data_Maybe.Nothing.value;
    };
    return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Foldable.minimumBy(Data_Foldable.foldableArray)(Sudoku_Internal.on(Data_Ord.compare(Data_Ord.ordInt))(function ($146) {
        return choices(Data_Tuple.snd($146));
    }))(possibilities))(function (min) {
        return Control_Bind.bind(Data_Maybe.bindMaybe)(fixCell(min))(function (v) {
            return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(new Data_Tuple.Tuple(Sudoku_Internal.replace2D(v.value0)(v.value1)(grid), Sudoku_Internal.replace2D(v.value0)(v.value2)(grid)));
        });
    });
};
var solve = function (v) {
    return function (grid) {
        var solve$prime = function (g) {
            if (isGridInvalid(v)(g)) {
                return Data_Maybe.Nothing.value;
            };
            if (isGridFilled(g)) {
                return new Data_Maybe.Just(g);
            };
            if (Data_Boolean.otherwise) {
                return Control_Bind.bind(Data_Maybe.bindMaybe)(nextGrids(g))(function (v1) {
                    var v2 = solve(v)(v1.value0);
                    if (v2 instanceof Data_Maybe.Just) {
                        return v2;
                    };
                    return solve(v)(v1.value1);
                });
            };
            throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 176, column 5 - line 183, column 10): " + [ g.constructor.name ]);
        };
        return Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(solve$prime)(pruneGrid(v)(grid));
    };
};
var solveAll = function (v) {
    return function (grid) {
        var solveAll$prime = function (g) {
            if (isGridInvalid(v)(g)) {
                return [  ];
            };
            if (isGridFilled(g)) {
                return [ g ];
            };
            if (Data_Boolean.otherwise) {
                return Data_Array.concat(Data_Array.fromFoldable(Data_Foldable.foldableMaybe)(Data_Functor.mapFlipped(Data_Maybe.functorMaybe)(nextGrids(g))(function (v1) {
                    return Data_Semigroup.append(Data_Semigroup.semigroupArray)(solveAll(v)(v1.value0))(solveAll(v)(v1.value1));
                })));
            };
            throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 190, column 5 - line 190, column 36): " + [ g.constructor.name ]);
        };
        return Data_Array.concat(Data_Array.fromFoldable(Data_Foldable.foldableMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(solveAll$prime)(pruneGrid(v)(grid))));
    };
};
var solveUnique = function (v) {
    return function (grid) {
        var searchResult = function (v1) {
            if (v1 instanceof Sudoku_Internal["NoSolution'"]) {
                return Sudoku_Internal.NoSolution.value;
            };
            if (v1 instanceof Sudoku_Internal["NotUnique'"]) {
                return new Sudoku_Internal.NotUnique(v1.value0, v1.value1);
            };
            if (v1 instanceof Sudoku_Internal["AtLeast'"]) {
                return new Sudoku_Internal.Unique(v1.value0);
            };
            throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 225, column 5 - line 225, column 48): " + [ v1.constructor.name ]);
        };
        var mergeSearch = function (v1) {
            return function (v2) {
                if (v1 instanceof Sudoku_Internal["NoSolution'"]) {
                    return v2;
                };
                if (v2 instanceof Sudoku_Internal["NoSolution'"]) {
                    return v1;
                };
                if (v1 instanceof Sudoku_Internal["NotUnique'"]) {
                    return v1;
                };
                if (v2 instanceof Sudoku_Internal["NotUnique'"]) {
                    return v2;
                };
                if (v1 instanceof Sudoku_Internal["AtLeast'"] && v2 instanceof Sudoku_Internal["AtLeast'"]) {
                    return new Sudoku_Internal["NotUnique'"](v1.value0, v2.value0);
                };
                throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 230, column 5 - line 230, column 46): " + [ v1.constructor.name, v2.constructor.name ]);
            };
        };
        var solveUnique$prime = function (v1) {
            return function (g) {
                return Data_Maybe.fromMaybe(Sudoku_Internal["NoSolution'"].value)(Data_Functor.map(Data_Maybe.functorMaybe)(solve2(v1))(pruneGrid(v1)(g)));
            };
        };
        var solve2 = function (v1) {
            return function (g) {
                if (isGridInvalid(v1)(g)) {
                    return Sudoku_Internal["NoSolution'"].value;
                };
                if (isGridFilled(g)) {
                    return new Sudoku_Internal["AtLeast'"](g);
                };
                if (Data_Boolean.otherwise) {
                    var v3 = nextGrids(g);
                    if (v3 instanceof Data_Maybe.Nothing) {
                        return Sudoku_Internal["NoSolution'"].value;
                    };
                    if (v3 instanceof Data_Maybe.Just) {
                        var v4 = solveUnique$prime(v1)(v3.value0.value0);
                        if (v4 instanceof Sudoku_Internal["NotUnique'"]) {
                            return v4;
                        };
                        return mergeSearch(v4)(solveUnique$prime(v1)(v3.value0.value1));
                    };
                    throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 219, column 29 - line 223, column 60): " + [ v3.constructor.name ]);
                };
                throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 215, column 5 - line 215, column 40): " + [ v1.constructor.name, g.constructor.name ]);
            };
        };
        return searchResult(solveUnique$prime(v)(grid));
    };
};
var allBut = function (v) {
    return function (v1) {
        return Sudoku_Internal.Possible.create(Data_Array["delete"](Data_Eq.eqChar)(v1)(v.value1));
    };
};
module.exports = {
    isPossible: isPossible,
    isFixed: isFixed,
    allBut: allBut,
    pruneCells: pruneCells,
    subGridsToRows: subGridsToRows,
    diagIdxs: diagIdxs,
    exclusivePossibilities: exclusivePossibilities,
    makeCell: makeCell,
    pruneCellsByFixed: pruneCellsByFixed,
    pruneCellsByExclusives: pruneCellsByExclusives,
    "pruneGrid'": pruneGrid$prime,
    pruneDiag: pruneDiag,
    diagonalOf: diagonalOf,
    replaceDiagonal: replaceDiagonal,
    pruneGrid: pruneGrid,
    fixM: fixM,
    choices: choices,
    nextGrids: nextGrids,
    isGridFilled: isGridFilled,
    isInvalidRow: isInvalidRow,
    isGridInvalid: isGridInvalid,
    solve: solve,
    solveAll: solveAll,
    solveUnique: solveUnique
};
